<div class="simple-buy-order container-fluid">
  <div class="row">
    <div class="col-12">

      <div class="form-simple-buy-order1 txt-center">
        <div class="row">
          <div class="col-2">
            <mat-form-field>
              <mat-select placeholder="conta">
                <mat-option value="0">Informe de rendimentos</mat-option>
                <mat-option value="1">Informe de rendimentos</mat-option>
                <mat-option value="2">Informe de rendimentos</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-2">
               <!-- <input type="text" matInput placeholder="ativo" disabled value="ATIVO"
              value={{currentSymbol}}
              >  -->

               <app-auto-complete (onsymbolChanged)="selectAsset($event)" [symbolAutoComplete]="currentSymbol"></app-auto-complete>

          </div>

          <div class="col-2">
            <mat-form-field>
              <!-- MISSING IN DOC -->
              <mat-select placeholder="precificação">
                <mat-option value="0">Informe de rendimentos</mat-option>
                <mat-option value="1">Informe de rendimentos</mat-option>
                <mat-option value="2">Informe de rendimentos</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-2">
            <mat-form-field>
              <input [formControl]="quantidade" type="number" matInput placeholder="quantidade" [(ngModel)]="model.quantity" [value]='model.quantity'>
              <mat-error *ngIf="quantidade.invalid " >*Campo obrigatório</mat-error>
              <mat-error *ngIf="quantidade.invalid && model.quantity < 0">*Valor deve ser maior que 0</mat-error>
            </mat-form-field>
          </div>

          <div class="col-3 size-area">
            <div class="right-side-top txt-center">
              <div>
                <span class="default">Compra </span>
                <span class="default-bold">{{model.quantity}} </span>
                <span class="default">ações de </span>
                <span class="default-bold">{{model.symbol}} </span>
                <span class="default">à </span>
                <span class="default-bold">{{ model.lastTrade }}</span>
              </div>
              <div>
                <span *ngIf='!currentSymbol' class="total">
                      -
                </span>
                <span *ngIf='currentSymbol' class="total">
                  TOTAL - R$ {{model.valorTotal}}
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="form-simple-buy-order2 txt-center">
        <div class="row">

          <div class="col-2">
            <mat-form-field>
              <mat-select placeholder="duração">
                 <mat-option ng-model="model.duration" *ngFor='let option of durationOptions' value="0">{{option.desc}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-2">
            <mat-form-field class="date">
              <input  ng-model="model.expiration" matInput [matDatepicker]="picker" placeholder="data do vencimento">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-2">

             <app-incremental-input name="model.price" [placeholder]= "'Preço de limite'" [options]="priceValuesFormatOptions" [price]="true" [roundLot]="1000"
            [isQuantity]="true" [minValue] = 0 [(ngModel)]="model.price" aria-required=""></app-incremental-input>

          </div>

          <div class="col-2">
              <app-incremental-input name="model.triggerPrice" [price]="true" [placeholder]= "'Preço de disparo'" [options]="priceValuesFormatOptions" [roundLot]="1000"
              [isQuantity]="true" [minValue] = 0 [(ngModel)]="model.triggerPrice" aria-required=""></app-incremental-input>
          </div>

          <div *ngIf="model.type=='buy'" class="col-3 size-area">
            <div class="size-area-button">
              <button mat-raised-button color="buy" class="mr-1">Comprar</button>
            </div>
          </div>

          <div *ngIf="type=='sell'" class="col-3 size-area">
              <div class="size-area-button">
                <button mat-raised-button color="sell" class="mr-1">Vender</button>
              </div>
            </div>

        </div>
      </div>

      <div class="row">

        <div class="col-2 tunnels">

          <div class="row elem">
            <div class="col-6 txt-left default-text">Tunel Máximo</div>
            <div class="col-6 txt-right default-bold">{{model.tunnelUpperLimit}}</div>
          </div>

          <div class="row elem">
            <div class="col-6 txt-left default-text">Tunel Mínimo</div>
            <div class="col-6 txt-right default-bold">{{model.tunnelLowerLimit}}</div>
          </div>
        </div>

        <div class="col-10">
          <div class="options-text">
            opções avançadas >
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
